import { AgendaTaskModel } from "./agenda-task-model";

export class CompanyAgendaModel {
  public constructor(init?: Partial<CompanyAgendaModel>) {
    Object.assign(this, init);
  }
  CompanyId: number;
  CompanyName: string;
  Tasks: AgendaTaskModel[];
}
